export default "__VITE_PUBLIC_ASSET__e9319c1b__"